exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-block-children .block.docx-heading3-block {\n  margin-top: 20px;\n  margin-bottom: 8px;\n  font-size: 20px;\n}\n.block.docx-heading3-block .el-icon-caret-bottom{\n  display: none;\n}\n.listitem:hover .block.docx-heading3-block .el-icon-caret-bottom{\n  display: inline-block;\n}\n", ""]);

// exports
